<template>
  <v-app class="login">
    <v-snackbar v-model="snackbar" color="error" top right>
      {{ msg }}
      <v-btn color="pink" flat @click="snackbar = false">
        <v-icon color="white">close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-container fluid class="login-page">
      <v-layout align-center justify-center row fill-height>
        <v-flex xs12 sm8 md6 lg4 xl3>
          <v-card class="login-card">
            <v-img
              class="app-logo"
              :src="require('@/assets/digitory/Light_Transparent.png')"
              height="150px"
              width="350px"
            />
            <v-form ref="form">
              <v-card-text>
                <v-layout align-center justify-center row wrap class="px-4">
                  <v-flex xs12 class="title text-xs-center">
                    <p class="title">Connection Setup</p>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      v-model="serverConfig"
                      :items="allowedServers"
                      item-text="name"
                      return-object
                      required
                      :rules="requiredRule"
                      label="Select Server"
                      outline
                      single-line
                    >
                      <!-- Custom dropdown items -->
                      <template slot="item" slot-scope="data">
                        <v-list-tile-content>
                          <v-list-item-title>{{
                            data.item.name
                          }}</v-list-item-title>
                          <v-list-item-subtitle class="caption">
                            {{ data.item.about }}
                          </v-list-item-subtitle>
                        </v-list-tile-content>
                      </template>
                    </v-select>
                  </v-flex>

                  <v-flex v-if="serverConfig.editIP" xs12>
                    <v-text-field
                      v-model="serverConfig.ip"
                      required
                      :rules="ruleIP"
                      outline
                      single-line
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 align-center py-2 class="text-xs-center">
                    <v-btn
                      color="success"
                      class="white--text"
                      @click.native="ping(serverConfig)"
                      :disabled="!validate()"
                    >
                      Connect
                      <v-icon>settings_remote</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>
<style>
.login {
  overflow: hidden;
}

.login-page {
  background-image: url("../../assets/finalbg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
}

.app-logo {
  margin-left: auto;
  margin-right: auto;
}
</style>

<script>
import VueIp from "vue-ip";
import { globalData } from "@/providers/global";

export default {
  name: "init-screen",
  components: {
    VueIp,
  },
  data() {
    return {
      msg: "",
      snackbar: false,
      allowedServers: globalData.$data.$allowedServers,
      serverConfig: globalData.$data.$getSelectedServerConfig(),
      requiredRule: [(v) => !!v || "This field is required."],
      ruleIP: [
        (v) => !!v || "IP address is required",
        (v) => {
          const ipPattern =
            /^(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)$/;
          return ipPattern.test(v) || "IP address must be valid";
        },
      ],
    };
  },
  methods: {
    validate() {
      if (this.$refs.form) {
        return !this.serverConfig.editIP || this.$refs.form.validate();
      }
      return !this.serverConfig.editIP;
    },
    ping(serverConfig) {
      let { url } = globalData.$data.$getUrls(
        serverConfig.serverId,
        serverConfig.ip
      );
      this.$root.$loader.start(
        "Trying to connect " + url + " , please wait",
        {}
      );
      this.$http
        .get(url, { params: { m: globalData.$data.$appMode } })
        .then(() => {
          globalData.$data.$editConnection(
            serverConfig.serverId,
            serverConfig.ip
          );
          this.$store.dispatch("connectCh");
          this.$router.push("/login");
        })
        .catch((resp) => {
          this.snackbar = true;
          this.msg = "Unable to reach server, contact support";
          if (resp.body && resp.body.status) {
            this.msg = resp.body.status;
          }
        })
        .finally(() => {
          this.$root.$loader.stop();
        });
    },
  },
};
</script>
